export const GET_TEAMS = 'parcel/viewTeams/GET_TEAMS';
export const GET_TEAMS_SUCCESS = 'parcel/viewTeams/GET_TEAMS_SUCCESS';
export const GET_TEAMS_ERROR = 'parcel/viewTeams/GET_TEAMS_ERROR';
